import { lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { baseRoutes, filterStepsTypes } from './appSettings';
import StartView from './views/startView/startView';
import PrimaryClassificationsView from './views/primaryClassificationsView/primaryClassificationsView';
import SecondaryClassificationsView from './views/secondaryClassificationsView/secondaryClassificationsView';
import HotelProductsView from './views/hotelProductsView/hotelProductsView';
import DestinationTraitsView from './views/destinationTraitsView/destinationTraitsView';
import PreferenceView from './views/preferenceView/preferenceView';
import LazyLoader from './components/lazyLoader/lazyLoader';

const Congratulations = lazy(() => import(/* webpackChunkName: "congratulations-view" */ /* webpackPrefetch: true */ './views/congratulations/congratulations'));

const RoutesContainer = () => {
  const location = useLocation();
  return (
    <TransitionGroup className={`vf-switch-wrapper ${location.pathname === `/${baseRoutes.START}` ? 'vf-switch-wrapper__no-margin' : ''}`}>
      <CSSTransition key={location.pathname} classNames="vf-switch-wrapper__transitions" timeout={300}>
        <Routes location={location}>
          <Route path={`/${baseRoutes.START}`} element={<StartView />} />
          
          <Route path={`/${filterStepsTypes.PRIMARY_CLASSIFICATIONS}`} element={<PrimaryClassificationsView />} />
          
          <Route path={`/${filterStepsTypes.SECONDARY_CLASSIFICATIONS}`} element={<SecondaryClassificationsView />} />
          
          <Route path={`/${filterStepsTypes.HOTEL_PRODUCTS}`} element={<HotelProductsView />} />

          <Route path={`/${filterStepsTypes.DESTINATION_TRAITS_SELECTION}`} element={<PreferenceView />} />
          
          <Route path={`/${filterStepsTypes.DESTINATION_TRAITS_DETAILS}`} element={<DestinationTraitsView />} />

          <Route path={`/${baseRoutes.CONGRATULATIONS}`} element={
            <Suspense fallback={<LazyLoader />}>
              <Congratulations />
            </Suspense>
          } />
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  )
}

export default RoutesContainer